function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.784 8L.827 2.046a1.12 1.12 0 010-1.589 1.135 1.135 0 011.593 0l6.75 6.746c.427.426.436 1.11.033 1.551l-6.778 6.792c-.22.22-.51.329-.797.329-.286 0-.576-.108-.797-.329a1.12 1.12 0 010-1.589L6.784 8z",
  fill: "#4F4F4F"
});

function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default SvgForward;